import { render, staticRenderFns } from "./FormulaAndServiceCard.vue?vue&type=template&id=94c09662&scoped=true&"
import script from "./FormulaAndServiceCard.vue?vue&type=script&lang=js&"
export * from "./FormulaAndServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./FormulaAndServiceCard.vue?vue&type=style&index=0&id=94c09662&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c09662",
  null
  
)

export default component.exports